import Filters from '../filters';
import {DebugBarTailwind} from '@kaxmedia/vuejs-components';
import vSelect from "vue-select";

// Vue
window.Vue = require('vue').default;
window.Vue.use(require('vue-cookies'));

window.Vue.use(Filters);
window.Vue.component('popup-offer-tw', require('@RESOURCES/js/components/tailwind/PopupOffer.vue').default);
window.Vue.component('subscription-form-tw', require('@RESOURCES/js/components/tailwind/SubscriptionForm.vue').default);
window.Vue.component('fake-checkbox-tw', require('@RESOURCES/js/components/tailwind/FakeCheckboxComponent.vue').default);
window.Vue.component('show-more-show-less-button-tw', require('@RESOURCES/js/components/tailwind/operator_list/ShowMoreShowLessButton.vue').default);
window.Vue.component('single-offer-tw', require('@RESOURCES/js/components/tailwind/operator_list/SingleOffer.vue').default);
window.Vue.component('operator-list-tab-tw', require('@RESOURCES/js/components/tailwind/operator_list/OperatorListTab.vue').default);
window.Vue.component('loading-spinner-tw', require('@RESOURCES/js/components/tailwind/LoadingSpinner.vue').default);
window.Vue.component('region-selector-tw', require('@RESOURCES/js/components/tailwind/RegionSelector.vue').default);
window.Vue.component('payment-methods-table-tw', require('@RESOURCES/js/components/tailwind/PaymentMethodsTable.vue').default);
window.Vue.component('state-exit-link-button-tw', require('@RESOURCES/js/components/tailwind/brand/content/StateExitLinkButton').default);
window.Vue.component('oplist-signup-form-tw', require('@RESOURCES/js/components/tailwind/operator_list/OplistSignupForm').default);
window.Vue.component('site-article-strategy-list-tw', require('@RESOURCES/js/components/tailwind/SiteArticleStrategy/SiteArticleStrategyList.vue').default);
window.Vue.component('age-checker-gb-tw', require('@RESOURCES/js/components/tailwind/age_checker/AgeCheckerGB.vue').default);
window.Vue.component('no-state-offer-tw', require('@RESOURCES/js/components/tailwind/NoStateOffer.vue').default);
Vue.component('newsletter-modal-tw', require('@RESOURCES/js/components/tailwind/NewsletterModal.vue').default);
Vue.component('selector', require('@RESOURCES/js/components/Selector.vue').default);
Vue.component('v-select', vSelect)

//Articles
window.Vue.component('article-item', require('@RESOURCES/js/components/articles/ArticleItem.vue').default);
window.Vue.component('article-featured', require('@RESOURCES/js/components/articles/ArticleFeatured.vue').default);
window.Vue.component('articles-global', require('@RESOURCES/js/components/articles/ArticlesGlobal.vue').default);
window.Vue.component('switch-button', require('@RESOURCES/js/components/SwitchButton').default);

window.Vue.component('switch-tw', require('@RESOURCES/js/components/tailwind/Switch.vue').default);
window.Vue.component('global-search-tw', require('@RESOURCES/js/tailwind/search/GlobalSearch').default);

if (document.getElementsByClassName('global-search-container navigation').length > 0) {
    new Vue({el: ".global-search-container.navigation"});
}
if (document.getElementsByClassName('global-search-container home-banner').length > 0) {
    new Vue({el: ".global-search-container.home-banner"});
}

// NFL Team Stats
Vue.component('nfl-team-stats', require('@RESOURCES/js/components/matrix/NflTeamStats.vue').default);
Vue.component('nfl-player-stats', require('@RESOURCES/js/components/matrix/NflPlayerStats.vue').default);


// Setup DebugBar Vue Component
if (document.getElementById('debug')) {
    new Vue({
        el: '#debug',
        components: {
            DebugBarTailwind,
        },
    });
}
